//t = current time
//b = start value
//c = change in value
//d = duration
const easeInOutQuad = function(t: number, b: number, c: number, d: number) {
  t /= d / 2
  if (t < 1) return (c / 2) * t * t + b
  t--
  return (-c / 2) * (t * (t - 2) - 1) + b
}

const scrollTo = (to: number, duration: number, target?: HTMLElement) => {
  const targetElement = target ?? window
  const start = target ? target.scrollTop : window.scrollY,
    change = to - start,
    increment = 20
  let currentTime = 0

  const animateScroll = () => {
    currentTime += increment
    const yCoord = easeInOutQuad(currentTime, start, change, duration)
    const xCoord = target ? target.scrollLeft : window.scrollX
    // Element.scrollTo()ない場合はreturn（IE11
    // https://developer.mozilla.org/ja/docs/Web/API/Element/scrollTo
    if (!targetElement.scrollTo) return
    targetElement.scrollTo(xCoord, yCoord)
    if (currentTime < duration) {
      setTimeout(animateScroll, increment)
    }
  }
  animateScroll()
}

export default scrollTo
